import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import SunsetBackground from './ui/SunsetBackground';

const Layout = () => {
  return (
    <div className="flex h-screen relative">
      <SunsetBackground />
      <Sidebar />
      <main className="flex-1 overflow-auto relative z-10">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
